export default __webpack_public_path__ + "static/media/waffle4.5ca795f4.png";